export enum MeetingFormat {
    Virtual = 1,
    InPerson = 2,
    Mixed = 3,
}

export const MeetingFormatTypesOptions = {
    [MeetingFormat.Virtual]: 'Virtual',
    [MeetingFormat.InPerson]: 'In-Person',
    [MeetingFormat.Mixed]: 'Mixed',
};